export default "__VITE_ASSET__ChYUhkB5__"